<template>
  <img src="~/assets/icon/icon-tg.svg" />
</template>
